import EE from 'events';
import { firebase, providers } from '@/db';

class Auth extends EE {
  constructor() {
    super();
    this.isInitialized = false;
    this.data = null;
  }

  // eslint-disable-next-line
  getClaims() {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdTokenResult(true)
        .then((idTokenResult) => {
          resolve({
            hasAccess: idTokenResult.claims.hasAccess,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  initiator() {
    return new Promise((resolve, reject) => {
      if (this.isInitialized) {
        console.log('AUTH: is initialized yet');
        return resolve(this.data);
      }
      console.log('AUTH: is not yet initialized - initializing...');
      return this.initialize().then((result) => {
        console.log('AUTH: initialized');
        return resolve(result);
      }).catch(reject);
    });
  }

  initialize() {
    return new Promise((resolve) => {
      firebase.auth().onAuthStateChanged((userData) => {
        const result = (user, claims) => {
          const data = {
            ...user,
            claims,
          };
          if (!this.isInitialized) {
            this.isInitialized = true;
          }
          this.data = data;
          this.emit('stateChanged', data);
          resolve(data);
        };

        if (userData) {
          this.getClaims().then((claims) => {
            result(userData, claims);
          }).catch(() => {
            result(userData, null);
          });
        } else {
          resolve(null);
        }
      });
    });
  }


  signInByPassword(email, password) {
    return new Promise((resolve, reject) => {
      this.isInitialized = false;

      firebase.auth().signInWithEmailAndPassword(email, password)
        .then((user) => {
          resolve(user);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  signInByFacebook() {
    return new Promise((resolve, reject) => {
      this.isInitialized = false;

      firebase.auth().signInWithPopup(providers.facebook).then((result) => {
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}

export default new Auth();
